export default "__VITE_ASSET__CF3yXusf__"